module.exports = __webpack_public_path__ + "img/dept-9.d6ca82da.svg";